import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, Chip, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { styled } from '@mui/system'
import "./monthlyPayments.css"
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import Loader from '../../components/Loader/Loader'
import Toptag from '../../components/toptag/Toptag'
import apiFunctions from '../../api/apiFunctions'
import { formatDateTime as fmtDateTime } from '../../utils/formatDate';
const NavPaper = styled(Paper)({
    padding: "20px",
    borderRadius: "8px",
    backgroundColor: "white",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

const BackPaper = styled(Paper)({
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export default function MonthlyPaymentDetail() {
    const [payment, setPayment] = useState(null);
    const [isLoading, setIsloading] = useState(true)
    const [confirmForm, setConfirmForm] = useState({
        tx_hash: '',
        wallet_role_paid: 'main',
        payout_token: '',
        payout_network_id: ''
    });
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');

    useEffect(() => {
        if (id) {
            getDetail();
        } else {
            navigate('/home/monthly-payouts');
        }
    }, [id])

    const getDetail = async () => {
        setIsloading(true);
        try {
            let result = await apiFunctions.getMonthlyPaymentDetail(id);
            if (!result.data.status) {
                if (result.data.code === 401) {
                    localStorage.clear();
                    navigate("/login")
                    toast.info("Session Expired Please login again!!")
                }
                toast.error(result.data.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
                navigate('/home/monthly-payouts');
            } else {
                setPayment(result.data.data);
                const mainWallet = (result.data.data.user_snapshot?.wallets || []).find((w) => w.role === 'main');
                setConfirmForm({
                    tx_hash: result.data.data.tx_hash || '',
                    wallet_role_paid: result.data.data.wallet_role_paid || 'main',
                    payout_token: result.data.data.payout_token || mainWallet?.reward_currency || '',
                    payout_network_id: result.data.data.payout_network_id || mainWallet?.network_id || ''
                });
                setIsloading(false)
            }
        } catch (error) {
            toast.error("Error loading payment detail", {
                position: toast.POSITION.TOP_RIGHT
            });
            navigate('/home/monthly-payouts');
        }
    }

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        return fmtDateTime(dateString);
    }

    const getStatusColor = (status) => {
        switch (status) {
            case 'paid':
                return 'success';
            case 'approved':
                return 'info';
            case 'pending':
                return 'warning';
            default:
                return 'default';
        }
    }

    const handleApprove = async () => {
        try {
            let result = await apiFunctions.approveMonthlyPayment(payment._id);
            if (result.data.status) {
                toast.success("Monthly payment approved successfully", {
                    position: toast.POSITION.TOP_RIGHT
                });
                getDetail();
            } else {
                toast.error(result.data.message || "Failed to approve payment", {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } catch (error) {
            toast.error("Error approving payment", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const handleConfirmPayment = async () => {
        try {
            let result = await apiFunctions.confirmMonthlyPayment(payment._id, confirmForm);
            if (result.data.status) {
                toast.success("Payment confirmed successfully", {
                    position: toast.POSITION.TOP_RIGHT
                });
                getDetail();
            } else {
                toast.error(result.data.message || "Failed to confirm payment", {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } catch (error) {
            toast.error("Error confirming payment", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    if (isLoading) {
        return (
            <div>
                <Toptag name="Monthly Payout Detail" />
                <Loader />
            </div>
        )
    }

    if (!payment) {
        return (
            <div>
                <Toptag name="Monthly Payout Detail" />
                <NavPaper style={{ marginTop: "20px", textAlign: "center" }}>
                    <Typography>Payment not found</Typography>
                    <Button onClick={() => navigate('/home/monthly-payouts')} style={{ marginTop: "10px" }}>
                        Back to List
                    </Button>
                </NavPaper>
            </div>
        )
    }

    const wallets = payment.user_snapshot?.wallets || [];

    return (
        <div>
            <Toptag name="Monthly Payout Detail" />
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
                <Grid item xs={12}>
                    <NavPaper>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                            <Typography variant="h6">Payment Information</Typography>
                            <div style={{ display: "flex", gap: "10px" }}>
                                {payment.status === 'pending' && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleApprove}
                                    >
                                        Approve
                                    </Button>
                                )}
                                {payment.status === 'approved' && (
                                    <>
                                        <div style={{ marginTop: '15px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                            <input
                                                className="popInput"
                                                placeholder="TX Hash"
                                                value={confirmForm.tx_hash}
                                                onChange={(e) => setConfirmForm({ ...confirmForm, tx_hash: e.target.value })}
                                            />
                                            <select
                                                className="popInput"
                                                value={confirmForm.wallet_role_paid}
                                                onChange={(e) => setConfirmForm({ ...confirmForm, wallet_role_paid: e.target.value })}
                                            >
                                                <option value="main">Pay main wallet</option>
                                                <option value="secondary">Pay secondary wallet</option>
                                            </select>
                                        </div>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={handleConfirmPayment}
                                            style={{ marginTop: '10px' }}
                                        >
                                            Confirm Payment
                                        </Button>
                                    </>
                                )}
                                <Button
                                    variant="outlined"
                                    onClick={() => navigate('/home/monthly-payouts')}
                                >
                                    Back to List
                                </Button>
                            </div>
                        </div>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="subtitle2" color="textSecondary">User Information</Typography>
                                        <Typography variant="body1"><strong>Name:</strong> {payment.user_snapshot?.user_name || '-'}</Typography>
                                        <Typography variant="body1"><strong>Email:</strong> {payment.user_snapshot?.email || '-'}</Typography>
                                        {wallets.map((wallet, index) => (
                                            <div key={index} style={{ marginTop: '10px' }}>
                                                <Typography variant="body2"><strong>{wallet.role === 'main' ? 'Main' : 'Secondary'} Wallet</strong></Typography>
                                                <Typography variant="body2">Address: {wallet.wallet_address || '-'}</Typography>
                                                <Typography variant="body2">Label: {wallet.wallet_label || '-'}</Typography>
                                                <Typography variant="body2">Network: {wallet.network_name || '-'}</Typography>
                                                <Typography variant="body2">Currency: {wallet.reward_currency || '-'}</Typography>
                                            </div>
                                        ))}
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="subtitle2" color="textSecondary">Payment Summary</Typography>
                                        <Typography variant="body1">
                                            <strong>Total USD:</strong> ${(payment.total_usd ?? payment.total_amount ?? 0).toFixed(2)}
                                        </Typography>
                                        {payment.token_amount_sent != null && (
                                            <Typography variant="body1">
                                                <strong>Token Sent:</strong> {payment.token_amount_sent} {payment.payout_token || ''}
                                            </Typography>
                                        )}
                                        {payment.tx_hash && (
                                            <Typography variant="body1"><strong>TX Hash:</strong> {payment.tx_hash}</Typography>
                                        )}
                                        <Typography variant="body1"><strong>Number of Rewards:</strong> {payment.reward_details?.length || 0}</Typography>
                                        <Typography variant="body1"><strong>Year:</strong> {payment.year}</Typography>
                                        <Typography variant="body1"><strong>Month:</strong> {monthNames[payment.month - 1]}</Typography>
                                        <Typography variant="body1"><strong>Status:</strong> 
                                            <Chip
                                                label={payment.status || 'pending'}
                                                color={getStatusColor(payment.status)}
                                                size="small"
                                                style={{ marginLeft: "10px" }}
                                            />
                                        </Typography>
                                        <Typography variant="body1"><strong>Created At:</strong> {formatDateTime(payment.createdAt)}</Typography>
                                        {payment.approved_at && (
                                            <Typography variant="body1"><strong>Approved At:</strong> {formatDateTime(payment.approved_at)}</Typography>
                                        )}
                                        {payment.payment_date && (
                                            <Typography variant="body1"><strong>Payment Date:</strong> {formatDateTime(payment.payment_date)}</Typography>
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </NavPaper>
                </Grid>
                <Grid item xs={12}>
                    <BackPaper>
                        <Typography variant="h6" style={{ marginBottom: "20px" }}>Reward Details</Typography>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Event Title</TableCell>
                                    <TableCell>Event Place</TableCell>
                                    <TableCell>Slot Time</TableCell>
                                    <TableCell>Duration (Hours)</TableCell>
                                    <TableCell>USD Amount</TableCell>
                                    <TableCell>Multiplier</TableCell>
                                    <TableCell>Double Reason</TableCell>
                                    <TableCell>Attendance Count</TableCell>
                                    <TableCell>Reason</TableCell>
                                    <TableCell>Reward Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {payment.reward_details && payment.reward_details.length > 0 ? (
                                    payment.reward_details.map((detail, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{detail.event_snapshot?.title || '-'}</TableCell>
                                            <TableCell>{detail.event_snapshot?.place || '-'}</TableCell>
                                            <TableCell>
                                                {detail.slot_snapshot?.startTime || '-'} - {detail.slot_snapshot?.endTime || '-'}
                                            </TableCell>
                                            <TableCell>{detail.slot_snapshot?.duration_hours || 0}</TableCell>
                                            <TableCell>${(detail.usd_amount ?? detail.reward_amount ?? 0).toFixed(2)}</TableCell>
                                            <TableCell>{detail.reward_multiplier || 1}x</TableCell>
                                            <TableCell>{detail.double_reward_reason || '-'}</TableCell>
                                            <TableCell>{detail.attendance_count || 0}</TableCell>
                                            <TableCell>{detail.reason || 'Attended slot with minimum required participants'}</TableCell>
                                            <TableCell>{formatDateTime(detail.reward_date)}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={10} align="center">No reward details found</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </BackPaper>
                </Grid>
            </Grid>
            <ToastContainer />
        </div>
    )
}
